import { Row } from "antd";
import React, { JSX, useMemo } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { useEffectOnce } from "react-use";
import { useRecoilValue } from "recoil";
import AntdTabs from "../../../components/AntdTabs/AntdTabs";
import Button from "../../../components/Button/Button";
import { CardContainer } from "../../../components/Card/CardContainer";
import SearchInput from "../../../components/Input/SearchInput";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { checkPermission } from "../../../components/Permission/Permission";
import Select from "../../../components/Select/Select";
import TablePagination from "../../../components/Table/TablePagination";
import Text from "../../../components/Text/Text";
import { shopDatasource } from "../../../datasource/ShopDatasource";
import { zoneDatasource } from "../../../datasource/ZoneDatasource";
import useDebounce from "../../../hook/useDebounce";
import { profileAtom } from "../../../store/ProfileAtom";
import { roleAtom } from "../../../store/RoleAtom";
import { checkCompany } from "../../../utility/CompanyName";

const mappingType = {
  SD: "Sub Dealer",
  DL: "Dealer",
};
function ApproveTelPage(): JSX.Element {
  const [keyword, setKeyword] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [currentZone, setCurrentZone] = React.useState("all");
  const navigate = useNavigate();
  const [tab, setTab] = React.useState("WAITING");
  const profile = useRecoilValue(profileAtom);
  const company = JSON.parse(localStorage.getItem("company")!);

  const roleData = useRecoilValue(roleAtom);
  const isView = checkPermission(["approvePhone", "view"], roleData);

  const [zone, setZone] = React.useState<{ label: string; value: string; key: string }[]>([]);
  const newZone = useMemo(() => {
    if (zone) {
      return [{ label: "เขต : ทั้งหมด", value: "all", key: "all" }, ...zone];
    } else {
      return [{ label: "เขต : ทั้งหมด", value: "all", key: "all" }];
    }
  }, [zone]);
  const debouncedValue = useDebounce(keyword, 500);
  const getZoneByCompany = async () => {
    const res = await zoneDatasource.getAllZoneByCompany(company?.companyCode);
    const data = res.map((item: any) => {
      return {
        label: item.zoneName,
        value: item.zoneName,
        key: item.zoneId,
      };
    });
    setZone(data);
  };
  useEffectOnce(() => {
    getZoneByCompany();
  });
  const { data } = useQuery(["approve", debouncedValue, page, tab, currentZone], async () => {
    const res = await shopDatasource.getApproveTel({
      company: company?.companyCode || "",
      text: keyword,
      page: page,
      isApprove: tab,
      zone: currentZone === "all" ? undefined : currentZone,
      take: 8,
    });
    console.log("app", res);
    return res;
  });

  const onClickApprove = (id: string) => {
    navigate({
      pathname: `ApproveTelCoporateShop`,
      search: `?id=${id}`,
    });
  };
  const dataTabs = [
    {
      label: data?.countWaiting ? `รออนุมัติ (${data?.countWaiting})` : "รออนุมัติ  (0)",
      key: "WAITING",
    },
    {
      label: data?.countApproved ? `อนุมัติแล้ว (${data?.countApproved})` : "อนุมัติแล้ว (0)",
      key: "APPROVE",
    },
    {
      label: data?.countUnapprove ? `ไม่อนุมัติ (${data?.countUnapprove})` : "ไม่อนุมัติ (0)",
      key: "UNAPPROVE",
    },
  ];

  const defaultTableColumns = useMemo(() => {
    const staticData = [
      {
        title: "Customer No.",
        dataIndex: "customerId",
        key: "customerId",
      },
      {
        title: "ชื่อร้านค้า",
        dataIndex: "customerCompany",
        key: "shopName",
      },
      {
        title: "ชื่อผู้ใช้",
        dataIndex: "customerName",
        key: "customerName",
      },
      {
        title: "เบอร์โทรศัพท์",
        dataIndex: "customerTel",
        key: "contact",
      },
      {
        title: (
          <Text color='success' fontWeight={600}>
            {company.companyCode}
          </Text>
        ),
        dataIndex: company?.companyCode,
        key: company?.companyCode,
      },
      {
        title: "การจัดการตรวจสอบ",
        key: "action",
      },
    ];

    const columns = staticData.map((item) => {
      return {
        key: item.key,
        dataIndex: item.dataIndex,
        title: item.title,

        fixed: item.key === "action" ? "right" : undefined,
        width: item.key === "action" ? 200 : undefined,
        // sorter: item.key === "contact" ? undefined : (a: any, b: any) => a[item.key] - b[item.key],
        render: (value: any, data: any) => {
          const findCurrentCompany = data?.customer?.customerCompany.find(
            (el: any) => el.company === profile?.company,
          );
          const userShop = data?.customer?.customerToUserShops[0]?.userShop;
          const findUserCoporate = data.customer.customerToUserShops;

          if (item.key === "contact") {
            const telList: any[] = [];
            if (data.newTelephone) {
              telList.push(data.newTelephone);
            }
            if (data.newSecondTelephone) {
              telList.push(data.newSecondTelephone);
            }
            return (
              <div>
                {telList.map((tel: any, index: number) => {
                  const isLast = index === telList.length - 1;
                  return <Text key={index}>{tel ? `${tel}${isLast ? "" : " , "}` : "-"}</Text>;
                })}
              </div>
            );
          }
          if (item.key === "shopName") {
            return (
              <div>
                <Row>
                  <Text>{findCurrentCompany ? findCurrentCompany.customerName : ""}</Text>
                </Row>
                <Text level={6} color='Text3'>
                  {`จ.${data.customer.province}`}
                </Text>
              </div>
            );
          }
          if (item.key === profile?.company) {
            return (
              <div>
                <Text fontWeight={700}>{`${
                  mappingType[findCurrentCompany.customerType as keyof typeof mappingType]
                } ・ ${findCurrentCompany.zone}`}</Text>
              </div>
            );
          }
          if (item.key === "action") {
            if (tab === "WAITING") {
              return (
                <>
                  {isView && (
                    <div>
                      <Button
                        title='ตรวจสอบเบอร์โทรศัพท์'
                        onClick={() => {
                          onClickApprove(data.id);
                        }}
                      />
                    </div>
                  )}
                </>
              );
            }
            return (
              <div>
                <Button
                  title='รายละเอียด'
                  typeButton='primary-light'
                  onClick={() => {
                    onClickApprove(data.id);
                  }}
                />
              </div>
            );
          }

          if (item.key === "customerName") {
            const telList: any[] = [];
            const userList: any[] = [];

            if (data.newTelephone) {
              telList.push(data.newTelephone);
            }
            if (data.newSecondTelephone) {
              telList.push(data.newSecondTelephone);
            }

            telList.map((x) => {
              userList.push(
                findUserCoporate.find(
                  (y) => `${y.userShop.telephone}` === `${x}` && !y.userShop.isDelete,
                ),
              );
            });
            // console.log("userList", userList);

            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {userList?.map((data: any, index: number) => {
                  return (
                    <Text key={index}>
                      {data?.userShop?.nametitle} {data?.userShop?.firstname}{" "}
                      {data?.userShop?.lastname}
                    </Text>
                  );
                })}
              </div>
            );
          }

          return (
            <div style={{ padding: 4 }}>
              <Text>{value ? `${value}` : "-"}</Text>
            </div>
          );
        },
      };
    });
    return columns;
  }, [tab]);

  return (
    <CardContainer>
      <PageTitle
        title='ตรวจสอบเบอร์โทรศัพท์'
        extra={
          <div
            style={{
              display: "flex",
              gap: 16,
            }}
          >
            <div>
              <SearchInput
                onChange={(e) => {
                  setKeyword(e.target.value);
                  setPage(1);
                }}
                placeholder='ค้นหาร้านค้า, รายชื่อ...'
                value={keyword}
              />
            </div>
            <div>
              <Select
                value={currentZone}
                onChange={(e) => {
                  setPage(1);
                  setCurrentZone(e);
                }}
                data={newZone}
                style={{
                  width: 180,
                  fontFamily: "Sarabun",
                }}
              />
            </div>
          </div>
        }
      />
      <AntdTabs
        data={dataTabs}
        onChange={(key) => {
          setTab(key);
          setPage(1);
          navigate(`?status=${key}`);
        }}
        defaultTab={tab}
      />
      <TablePagination
        data={data ? data.data : []}
        columns={
          checkCompany(company.companyCode)
            ? defaultTableColumns
            : defaultTableColumns.filter((x) => x.key !== company?.companyCode)
        }
        pagination={{
          current: page,
          total:
            tab === "WAITING"
              ? data?.countWaiting
              : tab === "APPROVE"
                ? data?.countApproved
                : data?.countUnapprove,
          pageSize: 8,
          onChange: (page) => {
            setPage(page);
          },
        }}
      />
    </CardContainer>
  );
}

export default ApproveTelPage;
